import { env } from './envVariables';

export const sysoApiConfig = {
    baseSYSOUrl: env.baseSYSOAPIUrl
}

export const ihiModeMap = new Map([
    [0, "Unknown"], [1, "Shutdown"], [2, "Waiting"], [3, "Startup"], [4, "Ready"], [5, "Standby"],
    [6, "Profile"], [7, "Peak Shaving"], [8, "Frequency Support"], [9, "Voltage Support"],
    [10, "Load Leveling"], [11, "Manual"], [12, "SOC Maintenance"], [13, "Ramp Maintenance"],
    [14, "ISO Dispatch"], [15, "Rejuvenation"], [16, "Maintenance"], [17, "Fault"],
    [18, "Grid Support"], [19, "DC Coupled Manual"], [20, "DC Coupled ISO Dispatch"],
    [21, "DC Coupled SOC Maintenance"], [22, "DC Coupled PV Support"]
]);

export const geModeMap = new Map([
    [0, "Fault"],
    [1, "Shutdown"],
    [2, "Default"],
    [3, "Remote P"],
    [4, "Firming"]
]);

export const eneonModeMap = new Map([
    [0, "Grid Following"], [1, "Grid Forming"], [2, "Direct Battery Control"],
    [3, "SOC Target"], [4, "Clipping Management"], [5, "Power Firming"],
    [6, "Clipping Management and Power Firming"], [7, "PV to Grid"]
]);

export const flexgenModeMap = new Map([
    [0, "PV Only"], [1, "Direct Battery Control"], [3, "PV Clipping"],
    [4, "Min System Output"], [7, "Shutdown"]
]);

export const indieModeMap = new Map([
    [0, "Ready"], [1, "Standby"], [2, "Running"], [3, "Stopping"],
    [4, "Fault"], [5, "Waiting"], [99, "Unknown"], [999, "Unknown"]
]);

export const heilaModeMap = new Map([
    [1, "Hard Discharge"], [2, "Charge"], [3, "Soft Discharge"]
]);

export const siteToModeMap = new Map([
    ['17qeqym', geModeMap],
    ['17qequh', geModeMap],
    ['17tjjak', eneonModeMap],
    ['17tkfn3', eneonModeMap],
    ['17qemb3', eneonModeMap],
    ['17qeeji', eneonModeMap],
    ['17qeb9b', eneonModeMap],
    ['17qeq3s', eneonModeMap],
    ['17tjh8k', eneonModeMap],
    ['17qenzq', eneonModeMap],
    ['17qeje8', flexgenModeMap],
    ['17qemjb', indieModeMap],
    ['17qek1u', indieModeMap],
    ['17qeirk', ihiModeMap],
    ['17qemwn', ihiModeMap],
    ['17q5s8d', ihiModeMap],
    ['17qegkh', ihiModeMap],
    ['17qeqxk', ihiModeMap],
    ['17qeura', ihiModeMap],
    ['17qehxt', ihiModeMap],
    ['17qeets', ihiModeMap],
    ['17tjhu6', ihiModeMap],
    ['17qegmi', ihiModeMap],
    ['17qerg4', ihiModeMap],
    ['17qegqm', ihiModeMap],
    ['17tjg1e', ihiModeMap],
    ['17qefec', ihiModeMap],
    ['17qeea9', ihiModeMap],
    ['17qem6y', ihiModeMap],
    ['17qemd5', ihiModeMap],
    ['17qefsq', heilaModeMap]
]);

export const scalingMap = new Map([
    ['default', { 'soc': 'divide10', 'power': null }],
]);

export const measureApiNameToConfigsMap = new Map([
    ['averageSoc', { 'type': 'decimal', 'label': 'Average SOC', 'decimalPlaces': 2 }],
    ['batteryExport', { 'type': 'decimal', 'label': 'Battery Export', 'decimalPlaces': 0 }],
    ['batteryImport', { 'type': 'decimal', 'label': 'Battery Import', 'decimalPlaces': 0 }],
    ['fullCycleEquivalents', { 'type': 'decimal', 'label': 'Full Cycle Equivalents', 'decimalPlaces': 2 }],
    ['gridOutput', { 'type': 'decimal', 'label': 'Grid Output', 'decimalPlaces': 0 }],

    ['capacitySupplyObligation', { 'type': 'decimal', 'label': 'Capacity Supply Obligation', 'decimalPlaces': 2 }],
    ['weightedClearingPrice', { 'type': 'currency', 'label': 'Weighted Clearing Price', 'decimalPlaces': 2 }],
    ['monthlyRevenue', { 'type': 'currency', 'label': 'Monthly Revenue', 'decimalPlaces': 2 }],

    ['assetId', { 'type': 'decimal', 'label': 'Asset', 'decimalPlaces': 2 }],
    ['hoursOnRegulation', { 'type': 'decimal', 'label': 'Hours on Regulation', 'decimalPlaces': 0 }],
    ['avgRips', { 'type': 'decimal', 'label': 'Average RIPS Score', 'decimalPlaces': 4 }],
    ['totalPayments', { 'type': 'currency', 'label': 'Total Payments', 'decimalPlaces': 2 }],
    ['avgCapacityCredit', { 'type': 'currency', 'label': 'Average Capacity Credit', 'decimalPlaces': 2 }],
    ['avgServiceCredit', { 'type': 'currency', 'label': 'Average Service Credit', 'decimalPlaces': 2 }],

    ['peakHourCpecs', { 'type': 'decimal', 'label': 'Peak Hour CPECs', 'decimalPlaces': 2 }],
    ['peakHourOutput', { 'type': 'decimal', 'label': 'Peak Hour Output', 'decimalPlaces': 0 }],
    ['seasonalHourCpecs', { 'type': 'decimal', 'label': 'Seasonal Hour Output', 'decimalPlaces': 0 }],
    ['seasonalHourOutput', { 'type': 'decimal', 'label': 'Seasonal Hour Output', 'decimalPlaces': 0 }],
    ['peakHour', { 'type': 'datetime', 'label': 'Peak Hour' }],
    ['totalCpecs', { 'type': 'decimal', 'label': 'Total CPECs', 'decimalPlaces': 0 }],

    ['marketRevenue', { 'type': 'currency', 'label': 'Market Revenue', 'decimalPlaces': 2 }],
    ['sysoFees', { 'type': 'currency', 'label': 'SYSO Fees', 'decimalPlaces': 2 }],
    ['totalRemittance', { 'type': 'currency', 'label': 'Total Remittance', 'decimalPlaces': 2 }],
    ['statementDate', { 'type': 'date', 'label': 'Statement Date' }],
    ['statementNumber', { 'type': 'string', 'label': 'Statement Number', 'decimalPlaces': 2 }],

    ['gridOutputDrv', { 'type': 'decimal', 'label': 'Grid Output DRV', 'decimalPlaces': 2 }],
    ['gridOutputIcapTarget', { 'type': 'decimal', 'label': 'Grid Output ICAP Target', 'decimalPlaces': 2 }],
    ['lsrvDispatchHours', { 'type': 'decimal', 'label': 'LSRV Dispatch Hours', 'decimalPlaces': 0 }]
]);

export const tableApiNameToLabel = new Map([
    ['batteryHealth', 'Battery Health'],
    ['isoNeCapacity', 'ISO-NE Capacity'],
    ['isoNeRegulation', 'ISO-NE Regulation'],
    ['maCleanPeak', 'MA Clean Peak'],
    ['remittanceSummary', 'Remittance Summary'],
    ['vder', 'New York VDER'],
    ['iesoFinancialDetail', 'IESO Financial Detail'],
    ['financialBilateral', 'Financial Bilateral'],
    ['dayAheadResults', 'Day Ahead Results']
]);

export const reportingPackagesEnabledForDetail = new Map([
    ['batteryHealth', false],
    ['isoNeCapacity', false],
    ['isoNeRegulation', false],
    ['maCleanPeak', false],
    ['remittanceSummary', false],
    ['vder', true],
    ['iesoFinancialDetail', true],
    ['financialBilateral', true],
    ['dayAheadResults', true]
]);

export const reportingPackagesEnabledForSummary = new Map([
    ['batteryHealth', true],
    ['isoNeCapacity', true],
    ['isoNeRegulation', true],
    ['maCleanPeak', true],
    ['remittanceSummary', true],
    ['vder', true],
    ['iesoFinancialDetail', false],
    ['financialBilateral', false],
    ['dayAheadResults', false]
]);

/* 
    useDemoSiteNames is a switch to use fake anonymized names 
    Future improvement: have this be driven off user 
*/
export const useDemoSiteNames = false;

export const demoSiteNames = [
    'Boylston', 'Commonwealth', 'Newbury',
    'Tremont', 'Beacon', 'Huntington', 'Marlborough',
    'Washington', 'Clarendon', 'Berkeley', 'Dartmouth',
    'Columbus', 'Exeter', 'Hereford', 'Gloucester',
    'Fairfield', 'Arlington', 'Stanhope', 'Yarmouth',
    'Copley', 'Somerset', 'Brimmer', 'Fenway', 'Bowdoin',
    'Newcomb', 'Ipswich', 'Shawmut', 'Temple', 'Congress', 'Court'
];

// ============ Northland Systems ============
export const allowedIESOSystemIds = new Set([
    "3dcfd88c-2033-4c59-9fd2-90e4975cb36a",
    "eea829e5-47e0-45c9-8213-2793a29f2c76"
]);
export const allowedIESOSite = new Set([
    "8bc585f9-ce28-4b13-bf66-c0dc94a0ce3d"
]);

export const iesoSiteIdToNodeMap = {
    "3dcfd88c-2033-4c59-9fd2-90e4975cb36a": "ONEIDA-LT.BATT_TG1",
    "eea829e5-47e0-45c9-8213-2793a29f2c76": "ONEIDA-LT.BATT_TG2"
};

// ============ NYISO Systems ============
export const allowedNyisoSystemIds = new Set([
    "10be4b20-64e3-4ce3-9f85-f9441d0f5714",
    "769e2b57-0814-4641-a0a6-a747a80f7780",
    "e05c1833-74cb-4b91-b2f0-718ad9d9b24c",
    "6d70708f-996d-4144-9e16-10756dab5508",
    "4797e61d-d307-4311-8cf9-f9d244e3cbdf",
    "a69e6d08-5763-48fc-a660-65af21f49ab0",
    "cf9beadc-9113-4f9d-ab6a-ae0997bb2ec1",
    "553e3e5d-0a8c-4a5e-a375-7c7c6a6b304b",
    "8a61f815-471c-4899-99c0-322f63d686f7",
    "6f5c1e5d-ce55-4bdf-bda6-d35971e9bf91",
    "3c5c9aa7-3659-43a4-a3e8-560d38a7e6dd",
    "b5713b14-cc69-4d6d-b70d-3ce098c7e58e",
    "d8e95996-69d1-4244-b1d0-a39c5e769ef6",
    "ae0a8c86-5b08-42a5-9c63-1a8297cae596",
    "660a35a9-2468-4190-b00e-70d2c9421e6a",
    "53d89c56-6c8d-4631-89a8-e1fbdd0342d3",
    "74de6d02-55ae-4a1f-aafe-dfe20857d794",
    "e2d014d1-52c7-4771-8d2e-888ae2f67502",
    "9a75b8dd-bd5f-4160-b258-8e01cd97aef1",
    "76aa182d-43ee-418e-b07c-5b8aa6c312b6",
    "5755cf41-c57d-4218-8240-c2849c114a83",
    "6b1ac207-03d4-4d6f-a2c6-670123f378ad",
    "6961a68a-269c-43b1-b9fd-b7bd1e0156a8"
]);

// ============ Solar-only Systems ============
export const allowedSolarOnlySystemIds = new Set([
    "681ef2cd-08fa-41a8-b2e9-1ee04f7011ee"   // Arevon Big Muddy
]);

export const breakerStatusMap = new Map([
    [0, "Open"], [1, "Closed"]   //  Grafana breaker_status panel mapping
]);